export const getRandomNumber = (min: number = 0, max: number = Number.MAX_SAFE_INTEGER) => Math.floor(Math.random() * (max - min)) + min;
